import clsx from "clsx";
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";
import FieldLabel from "../FieldLabel/FieldLabel";
import { motion, useReducedMotion } from "framer-motion";
import { ICON_SIZES } from "src/constants/icons";

export interface IRadioInput {
  label?: string;
  description?: string;
  selected?: boolean;
  value: string | number;
  onClick: () => void;
  labelClass?: string;
}

const RadioInput: React.FC<IRadioInput> = ({
  label,
  description,
  selected,
  value,
  onClick,
  labelClass,
}) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <div
      className={clsx([
        "flex",
        "flex-row",
        "w-full",
        "gap-1",
        "items-center",
        "justify-start",
        "cursor-pointer",
        "max-w-full",
      ])}
      onClick={onClick}
    >
      <motion.div
        key={selected ? "selected" : "deselected"}
        {...(!prefersReducedMotion && {
          initial: { scale: selected ? 0.8 : 1, opacity: selected ? 0 : 1 },
          animate: { scale: 1, opacity: 1 },
          exit: { scale: 0.8, opacity: 0 },
          transition: { duration: 0.2, ease: "easeInOut" },
        })}
      >
        {selected ? (
          <MdRadioButtonChecked
            size={ICON_SIZES.MD}
            className={clsx([
              "cursor-pointer",
              "shrink-0",
              "md:text-emerald-400",
              "text-emerald-400",
              "dark:text-cyan-400",
            ])}
          />
        ) : (
          <MdRadioButtonUnchecked
            size={ICON_SIZES.MD}
            className={clsx([
              "cursor-pointer",
              "shrink-0",
              "md:text-emerald-400",
              "text-emerald-400",
              "dark:text-cyan-400",
            ])}
          />
        )}
      </motion.div>

      {[!!label, !!description]?.includes(true) && (
        <div className="block">
          <div
            className={clsx(["flex", "flex-col", "max-w-full", "truncatex"])}
          >
            {label && (
              <FieldLabel
                text={label}
                className={clsx(["cursor-pointer", labelClass])}
              />
            )}
            {description && (
              <div
                className={clsx(["flex", "w-full", "text-xs", "md:text-xs"])}
              >
                {description}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RadioInput;
